/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { InsightGlobalConfigContainer } from '@jira/servicedesk__insight-global-configuration-store/src/useInsightGlobalConfig.tsx';
import {
	useInsightVisibility,
	useWorkspaceContext,
} from '@jira/servicedesk__insight-common-services-workspace-context/src/useWorkspaceContext.tsx';
import { isLicensedPremiumUser } from '@jira/servicedesk__insight-common-services-workspace-context/src/fetchWorkspaceId.tsx';
import { fireTrackAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { AssetsMenu, AssetsSingleMenuItem } from './assets-menu/index.tsx';
import { AssetsAppItem } from './assets-app-item/index.tsx';

export type Nav4AssetsProps = {
	isExpanded: boolean;
};

export function Nav4Assets({ isExpanded }: Nav4AssetsProps): React.JSX.Element {
	const tenantContext = useTenantContext();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	// useInsightVisibility can help fetch WorkspaceId
	const _ = useInsightVisibility();
	const isPremiumUser = isLicensedPremiumUser(tenantContext);
	const { workspaceId } = useWorkspaceContext();

	if (!isPremiumUser) {
		fireTrackAnalytics(createAnalyticsEvent({}), 'cmdbUpsellPageButton viewed', {
			serviceDeskEdition: tenantContext.appEditions?.serviceDesk,
			isSiteAdmin: tenantContext.isSiteAdmin,
		});

		if (fg('assets_as_an_app_v2')) {
			return <AssetsAppItem showUpsell />;
		}
		return <AssetsSingleMenuItem showUpsellLozenge />;
	}

	if (fg('assets_as_an_app_v2')) {
		return <AssetsAppItem showUpsell={false} />;
	}
	return workspaceId ? (
		<InsightGlobalConfigContainer
			isGlobal
			workspaceId={workspaceId}
			createAnalyticsEvent={createAnalyticsEvent}
			disableOnInit
		>
			<AssetsMenu isExpanded={isExpanded} />
		</InsightGlobalConfigContainer>
	) : (
		<AssetsSingleMenuItem showUpsellLozenge={false} />
	);
}
